<template>
	<div id="app">
		<page-loading :loading="page.loading"></page-loading>
		<div v-if="!page.loading">
			<router-view />
		</div>
	</div>
</template>

<style lang="scss">
	@import 'app.scss';
</style>

<script>
	import axios from 'axios';

	export default {
		name: 'app',
		data() {
			return {
				page: {
					loading: true,
					errors: []
				}
			}
		},
		async created() {
			//this.get();
			await this.getWebsiteText();
			await this.checkAuth();
		},
		methods: {
			async checkAuth() {
				this.page.errors = [];
				this.page.loading = true;

				try {
					const response = await this.$http.get('auth/check', this.getTokenHeader());
					this.$store.commit('login', {
						token: localStorage.getItem('auth_token'),
						user: response.data
					});
				} catch (error) {
					this.page.errors = this.logError(error);
				}

				this.page.loading = false;
			},
			async getWebsiteText() {
				this.page.errors = [];
				this.page.loading = true;

				try {
					const response = await this.$http.get('datasets/websitetext');
					this.$store.commit('setupSite', {
						siteText: response.data
					});

					if (!this.isNullOrEmpty(response.data.siteName)) {
						document.title = `${response.data.siteName} | ${response.data.siteLongName}`;
					}
				} catch (error) {
					this.page.errors = this.logError(error);
				}

				//this.page.loading = false;
			},
			/*get() {
				var self = this;
				axios.all([this.$http.get('auth/check', this.getTokenHeader()), this.$http.get('datasets/websitetext')])
					.then(axios.spread(function (authResponse, dataResponse) {
						self.$store.commit('login', {
							token: localStorage.getItem('auth_token'),
							user: authResponse.data
						});

						self.$store.commit('setupSite', {
							siteText: dataResponse.data
						});

						self.page.loading = false;
					}))
					.catch(error => {
						self.page.errors = self.logError(error);
						self.page.loading = false;
					});
			}*/
		}
	}
</script>
